import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  //   TableRow,
} from "../../../Table/TableBasic";
import OpretNyButtonBlock from "../../person/id/OpretNyButtonBlock";
import WordDocumentIcon from "../../../icons/WordDocumentIcon";

export default function Dokumentskabeloner() {
  return (
    <div className="container">
      <h3 className="d-flex gap-2 align-items-center">
        <span className="c-theme-icon c-theme-icon--defaultSize text-primary bg-primary-light">
          <WordDocumentIcon width={18} />
        </span>
        <span>Dokumentskabeloner</span>
      </h3>
      <div className="table-responsive">
        <ModalProvider>
          <TableRoot>
            <TableHead>
              <>
                {/* {getHeaderActiveColumns(linjeKursusholdColumns, {
                    defaultSortBy,
                    setSortBy,
                    sortBy,
                    })} */}
                <th>Navn</th>
                <th>Init</th>
                <th>Rettedato</th>
                <th>Register / tabel</th>
                <th>Fil</th>
              </>
            </TableHead>
            <TableBody>
              {/* {orderBy(
                        kursushold,
                        sortBy.map((s) => s.field),
                        sortBy.map((s) => s.direction)
                    ).map((hold, i) => {
                        return (
                        <TableRow key={i}>
                            <>
                            {linjeKursusholdColumns
                                .filter((col) => col.active)
                                .map((col) => {
                                return <TD key={col.field} col={col} rowData={hold} />;
                                })}
                            </>
                        </TableRow>
                        );
                    })} */}
              <tr>
                <td>Skabelon</td>
                <td>BTM</td>
                <td>12.12.2012</td>
                <td>Tabel</td>
                <td>Fil ex</td>
                <td></td>
              </tr>
            </TableBody>
          </TableRoot>
          {/* <ColumnEditorModal
                    defaultColumns={defaultLinjeKursusholdColumns}
                    columns={linjeKursusholdColumns}
                    setColumns={setLinjeKursusholdColumns}
                /> */}
          <OpretNyButtonBlock />
        </ModalProvider>
      </div>
    </div>
  );
}
